import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../common';
import {
    CCRewardsEventGroups,
    CCUserCardRewardInfo,
    GetCCCardMonthSummaryResponse,
    CCMonthlyBreakdownResponse,
    CCMonthlyComparisonResponse,
    CCTransactionsResponse,
} from './credit-card-rewards-types';

export const creditCardRewardsApiSlice = createApi({
    reducerPath: 'creditCardRewardsApi',
    baseQuery: baseQuery,
    tagTypes: [
        CCRewardsEventGroups.CC_CARD_MONTH_SUMMARY,
        CCRewardsEventGroups.CC_MONTH_YEAR_BREAKDOWN,
        CCRewardsEventGroups.CC_MONTH_YEAR_COMPARISON,
        CCRewardsEventGroups.CC_TRANSACTIONS,
    ],
    endpoints: (builder) => ({
        getCCCardMonthSummary: builder.query<GetCCCardMonthSummaryResponse, void>({
            query: () => ({
                url: 'cc/cardMonthSummary',
                method: 'GET',
            }),
            providesTags: [CCRewardsEventGroups.CC_CARD_MONTH_SUMMARY],
        }),
        getCCMonthYearCardBreakdown: builder.query<CCMonthlyBreakdownResponse, CCUserCardRewardInfo>({
            query: ({ userCardRewardId }) => ({
                url: `cc/monthYearCardBreakdown/:${userCardRewardId}`,
                method: 'GET',
            }),
            providesTags: [CCRewardsEventGroups.CC_MONTH_YEAR_BREAKDOWN],
        }),
        getCCMonthYearCardComparison: builder.query<CCMonthlyComparisonResponse, CCUserCardRewardInfo>({
            query: ({ userCardRewardId }) => ({
                url: `cc/monthYearCardComparison/:${userCardRewardId}`,
                method: 'GET',
            }),
            providesTags: [CCRewardsEventGroups.CC_MONTH_YEAR_COMPARISON],
        }),
        getCCTransactions: builder.query<CCTransactionsResponse, CCUserCardRewardInfo>({
            query: ({ userCardRewardId }) => ({
                url: `cc/transactions/:${userCardRewardId}`,
                method: 'GET',
            }),
            providesTags: [CCRewardsEventGroups.CC_TRANSACTIONS],
        }),
    }),
});

export const {
    useGetCCCardMonthSummaryQuery,
    useGetCCMonthYearCardBreakdownQuery,
    useGetCCMonthYearCardComparisonQuery,
    useGetCCTransactionsQuery,
    useLazyGetCCCardMonthSummaryQuery,
    useLazyGetCCMonthYearCardBreakdownQuery,
    useLazyGetCCMonthYearCardComparisonQuery,
    useLazyGetCCTransactionsQuery,
} = creditCardRewardsApiSlice;
